<script setup lang="ts">
import { useRoute } from 'vue-router';

import * as routeNames from '@/constants/routeNames';

const route = useRoute();
</script>

<template>
  <div v-if="route?.meta?.titles" :class="$style.barTitleText">
    <span
      v-for="(titleName, titleIndex) in route.meta.titles"
      :key="titleIndex"
    >
      <span v-if="titleIndex === 0" :class="$style.firstTitle">
        {{ titleName }}
      </span>
      <span v-else>
        &nbsp;/
        <!-- TODO document.title HACK jobId, ticketId title -->
        <template
          v-if="
            route.name === routeNames.JOB_HISTORY ||
            route.name === routeNames.DETAILED_PARAM_JOB ||
            route.name === routeNames.DETAILED_QUERY_JOB
          "
        >
          <span
            v-if="route.params.job_id || route.query.job_id"
            :class="$style.nextTitle"
          >
            #{{ route.params.job_id || route.query.job_id }}
          </span>
        </template>
        <template v-else-if="route.name === routeNames.SERVICE_DESK_TICKET">
          <span v-if="route.params.ticket_id" :class="$style.nextTitle">
            #{{ route.params.ticket_id }}
          </span>
        </template>
        <template v-else>
          <span :class="$style.nextTitle">{{ titleName }}</span>
        </template>
      </span>
    </span>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.barTitleText {
  display: flex;
  align-items: center;
  height: 100%;
  font-size: 18px;
  font-weight: 500;
  color: colors.$color-text-primary;
}
  .firstTitle {
    font-size: 24px;
  }
  .nextTitle {
    color: colors.$color-text-secondary;
  }
</style>
